import React from 'react';
import { OFFER_ANCHOR } from '../data/fono';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  variant?: 'coral' | 'turq';
}
export function CTAButton({
  children,
  className = '',
  href = OFFER_ANCHOR,
  variant = 'coral'
}: CTAButtonProps) {
  const styles = variant === 'coral' ? 'bg-coral text-white hover:bg-[#f4907f] border-b-4 border-[#c65a4b]' : 'bg-turq text-white hover:bg-[#3fbab2] border-b-4 border-[#176B73]';
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-xl px-3 py-3 text-center text-[13px] font-extrabold uppercase leading-tight tracking-wide shadow-lg
        transition-[background-color,transform,box-shadow] duration-150 ease-soft
        hover:-translate-y-0.5 active:translate-y-0 active:border-b-2
        focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal
        sm:text-base ${styles} ${className}`} data-id="element-28" data-mp="2p0t3bhd5olkm">
      {children}
    </a>;
}